import {useRef} from "react";

import {IOption} from "@pg-design/select-module";
import {Country} from "@pg-rp/common-types";

import {useLazyGetMapRegionsQuery} from "../api/get_map_region";
import {GetListMapRegionItemDto} from "../types/GetListMapRegionItemDto";

const MIN_SEARCH_INPUT_LENGTH = 2;
const SEARCH_DEBOUNCE_MS = 300;

interface IParams {
    country?: Country;
}

const mapRegionsToOptions = (regions: GetListMapRegionItemDto[]): IOption<number>[] =>
    regions.map((region) => ({
        label: region.short_name,
        value: region.id
    }));

export const useLocationAutocomplete = (params?: IParams) => {
    const {country} = params ?? {};

    const [fetchRegions] = useLazyGetMapRegionsQuery();
    const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const loadOptions = async (inputValue: string): Promise<IOption<number>[]> => {
        return new Promise((resolve) => {
            if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);

            if (!inputValue || inputValue.length < MIN_SEARCH_INPUT_LENGTH) return resolve([]);

            debounceTimeoutRef.current = setTimeout(async () => {
                try {
                    const response = await fetchRegions({country, regionFullName: inputValue}, true).unwrap();
                    resolve(mapRegionsToOptions(response?.results ?? []));
                } catch (error) {
                    console.error("Error fetching location suggestions:", error);
                    resolve([]);
                }
            }, SEARCH_DEBOUNCE_MS);
        });
    };

    return {
        loadOptions
    };
};
import {useRef} from "react";

import {IOption} from "@pg-design/select-module";
import {Country} from "@pg-rp/common-types";

import {useLazyGetMapRegionsQuery} from "../api/get_map_region";
import {GetListMapRegionItemDto} from "../types/GetListMapRegionItemDto";

const MIN_SEARCH_INPUT_LENGTH = 2;
const SEARCH_DEBOUNCE_MS = 300;

interface IParams {
    country?: Country;
}

const mapRegionsToOptions = (regions: GetListMapRegionItemDto[]): IOption<number>[] =>
    regions.map((region) => ({
        label: region.short_name,
        value: region.id
    }));

export const useLocationAutocomplete = (params?: IParams) => {
    const {country} = params ?? {};

    const [fetchRegions] = useLazyGetMapRegionsQuery();
    const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const loadOptions = async (inputValue: string): Promise<IOption<number>[]> => {
        return new Promise((resolve) => {
            if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);

            if (!inputValue || inputValue.length < MIN_SEARCH_INPUT_LENGTH) return resolve([]);

            debounceTimeoutRef.current = setTimeout(async () => {
                try {
                    const response = await fetchRegions({country, regionFullName: inputValue}, true).unwrap();
                    resolve(mapRegionsToOptions(response?.results ?? []));
                } catch (error) {
                    console.error("Error fetching location suggestions:", error);
                    resolve([]);
                }
            }, SEARCH_DEBOUNCE_MS);
        });
    };

    return {
        loadOptions
    };
};
